<template>
  <base-modal 
      icon-modal="share"
      modal-subtitle="You can save or share your study plan by copying the link below."
      modal-title="Save/Share plan"
      text-confirm="Copy to Clipboard"
      text-confirm-clicked="Copied!"
      text-discard="Start Over"
      :closing-offered="true"
      :confirmation-disabled="false"
      :discarding-disabled="false"
      :confirmation-required="true"
      modal-name="ShareModal"
      :close-on-confirm="false"
      :discarding-offered="false"
      :length="275"
      :body-gap="10"
      @confirm="copy(EncodedSaveData)"
  >
    <template #body>
      <div>
        <div class="copy-section">
          <div class = "scrolltext">
            {{ EncodedSaveData }}
          </div>

          
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script>

import { mapGetters} from 'vuex';
import BaseModal from "@/components/modals/BaseModal.vue";

export default {
  name: "ShareModal",
  props: {
    
  },
  components: {BaseModal},
  computed: {
    ...mapGetters([ 'EncodedSaveData']),
     
  },
  data() {
   return {
    copied: false,
  };
  },
  methods:{
    async copy(text) {
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text);
        return;
      }
      try {
        await navigator.clipboard.writeText(text);
        this.handleCopySuccess();
      } catch (err) {
        console.error('Async: Could not copy text: ', err);
        this.fallbackCopyTextToClipboard(text);
      }
    },
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      
      // Ensure it's not visible but part of the DOM
      textArea.style.position = 'fixed';
      textArea.style.left = '-9999px';
      textArea.style.top = '0';
      
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.handleCopySuccess();
        } else {
          alert('Cannot copy');
        }
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
        alert('Cannot copy');
      }

      document.body.removeChild(textArea);
    },
    handleCopySuccess() {
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 1500);
    }
  },
  
  
};
</script>

<style scoped>
.copy-section{
  display: flex; 
  align-items: center; 
  gap: 8px;
  padding: 10px 0px;

}
.scrolltext {
    overflow-x: auto; 
    white-space: nowrap; 
    padding: 6px 10px; 
    border: 1px solid #ccc; 
    border-radius: 6px;
}
</style>